import { render, staticRenderFns } from "./DiagDetail.vue?vue&type=template&id=0bf14a65&scoped=true"
import script from "./DiagDetail.vue?vue&type=script&lang=js"
export * from "./DiagDetail.vue?vue&type=script&lang=js"
import style0 from "./DiagDetail.vue?vue&type=style&index=0&id=0bf14a65&prod&scoped=true&lang=css"
import style1 from "./DiagDetail.vue?vue&type=style&index=1&id=0bf14a65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf14a65",
  null
  
)

export default component.exports